<template>
    <div @click="state.isOpen = true" class="cursor-pointer" v-bind="$attrs">
        <slot></slot>
    </div>
    <ModalCustom
        :is-open="state.isOpen"
        @close="state.isOpen = false"
        title="Rename Play"
    >
        <form action="/plays/rename" method="POST">
            <input type="hidden" name="_token" :value="$root.csrfToken" />
            <input type="hidden" name="play_id" :value="props.play.play_id" />
            <app-input
                name="play_name"
                placeholder="Play name"
                v-model="state.play_name"
            ></app-input>
            <div class="flex mt-4 justify-end">
                <button
                    type="submit"
                    class="
                        rounded-full
                        bg-gradient-to-br
                        py-2
                        px-6
                        from-primaryLight
                        to-primary
                        text-white
                        p-1
                    "
                >
                    Save
                </button>
            </div>
        </form>
    </ModalCustom>
</template>

<script setup>
import { defineProps, reactive } from "vue";

const props = defineProps(["play"]);

const state = reactive({
    isOpen: false,
    play_name: props.play.play_name,
});
</script>
